import { render, staticRenderFns } from "./ReportProfit.vue?vue&type=template&id=66a85370&scoped=true&"
import script from "./ReportProfit.vue?vue&type=script&lang=js&"
export * from "./ReportProfit.vue?vue&type=script&lang=js&"
import style1 from "./ReportProfit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a85370",
  null
  
)

export default component.exports